module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter01"
    }
  }, [_c('p', {
    staticClass: "ch-num"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("I")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_vm._v("The Cocktail Party")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Perhaps a cookery book should start in a less frivolous fashion than with a chapter headed ‘The Cocktail Party,’ and should show in its initial stages a proper seriousness of purpose and general sober-mindedness. But I had an idea that perhaps a light-hearted approach might present a more immediate appeal. One never knows, indeed, what trifle may awaken the enthusiasm necessary to carry one beyond the early arduous tasks connected with cooking into those realms in which cookery is an art and a pleasure. Rosemary Hume and I have noticed that a lesson or a demonstration on cocktail savouries is always popular, conjuring up as it does a vista of successful parties to be held in the future, and imparting a touch of glamour to the basic realities of the kitchen. Well, if the desire to excel in making good bouchées encourages a student to achieve mastery with pastry, all is well. Maybe this chapter should be regarded as the jam with the powder, the carrot before the donkey, but no matter if it serves to lure anyone on in the kitchen. It is only fair to admit that neither R. H. nor I set great store by cocktails or their accompanying savouries, regarding them, as it were, as menaces to the appreciation of good food.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Some cocktails, particularly the more potent of them, may blunt the palate, and preliminary savouries the appetite. The basic idea that a cocktail is intended to stimulate the appetite loses its point when one considers the profusion of food and drink usually presented at a cocktail party. At this point I am reminded of a paragraph that struck me in one of three articles written by Rebecca West for the "), _c('i', [_vm._v("New Yorker")]), _vm._v(" early in 1953. The articles were called ‘The Annals of Treason’ and dealt with the case of William Martin Marshall, the radio telegraphist, who became involved with a Soviet agent in London and was tried for espionage. His parents felt that the whole trouble had started in Russia, where they thought he had followed a life to which he was not accustomed, and Rebecca West goes on:")]), _vm._v(" "), _c('div', {
    staticClass: "disp-quote"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("There were continual parties. Cocktail parties. The sharp sound of the words, flung out after a preparatory pause, recalled that there was an age not so long ago when a cocktail was considered an immoral drink, as different from sherry as concubinage is from marriage, and a cocktail party meant an assembly of people who had abandoned normal restraints. A change in custom in one group may take a very long time to become known in other groups. There was, indeed, no reason for a household like this, which drank either beer or, more probably, only soft drinks, ever to have learned that cocktails had long since become respectable, and that cocktail parties had for many people moved up to the position, formerly occupied by tea parties, of social functions too stereotyped to be anything but tedious.")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Whether one likes such parties or not, it appears that for the moment at any rate they have come to stay and have their uses, and that being so, if you give one at all let it be of the best, a best which is not necessarily achieved by serving too many or too strong drinks.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("When in England we first adopted the cocktail party we were inclined to timidity, and the range of savouries offered was conservative as to size and variety. Even yet there is a tendency in this direction. Too many little mouthfuls, canapés, bouchées and suchlike, can be monotonous. I personally like better to have one or two main dishes of undeniable popularity, every bit of which will be eaten, and which will send no one home feeling blown up with starch. For instance, if I were feeling extravagant I should choose perhaps as my "), _c('i', [_vm._v("pièce de résistance")]), _vm._v(" the prawn dish with Alabama sauce, or if economically bent the cream cheese dish; and I should moderate the number of small savouries accordingly. One must of course differentiate between the various occasions for which cocktail savouries are required, and they may fall under the following headings:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("(a) Small savouries served with drinks before a dinner party. These should not be too substantial and need not be greatly varied, and such things as nuts, olives, small cheese biscuits, and tiny canapés are adequate. The canapés should be of a size that can comfortably be eaten in one mouthful.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("(b) Savouries for the cocktail party lasting perhaps from six to eight o’clock, at which may be offered a certain number of fairly substantial items.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("(c) Savouries for the pre-theatre cocktail party, when you know your guests will not be eating seriously until much later, and a few fairly solid savouries will be welcome.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("It may well be emphasized at the outset that the success of this type of food depends more on seasoning, flavouring, and pleasing contrast of texture than on elaborate and expensive materials, and that particular consideration should be given to presentation, and ease of serving and eating. Remembering the worst and the best of such parties clarifies my ideas, and I will tell of those features which made or marred them for me. On a less successful occasion I remember thinking it a great mistake to have so large a number of savouries of one type. The labour-saving device resorted to for this party of making one large batch of pastry and ringing the changes on the filling might possibly have been all right if some more refreshing and contrasting items had been offered, but the addition of filled bridge rolls and bread sandwiches to an array of pastry cases did not produce happy results. The sum total was stuffy and starchy. Too many similar textures are also tiresome; creamy fillings in bouchées and creamy spreads for canapés become extremely cloying. So bearing in mind the need for refreshment for the palate, it is well to vary the pastry, bread, or biscuit theme of these savouries, perhaps with celery as in the recipe on ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#page_6"
    }
  }, [_vm._v("page 6")]), _vm._v(", or by offering stuffed grapes or cherries; or by having a large bowl of raw vegetables – "), _c('i', [_vm._v("les crudités –")]), _vm._v(" which are a feature of one popular Paris restaurant in particular, where you may find a few small mushrooms among the young carrots, celery, radishes, spring onions, lettuce, and chicory. A bowl of rough salt should be at hand if this refreshment appears on the cocktail table. If it is chosen as a first course for luncheon on a hot day, it calls for fresh French or home-made rolls with ice-cold curls of butter.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At one of the best cocktail parties I remember, attention was centred on two large dishes, one hot and one cold. There was an adequate supply of these and there were not a great many little savouries, though there were a few: grapes filled with cream cheese, for instance, celery with Stilton cheese and so on; but the main attention had been focused on one or two popular things which proved successful.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The presentation of food at a cocktail party has importance. The larger dishes should look and taste exciting and are generally eaten to the last morsel. The smaller savouries, bouchées, canapés and so forth, may be arranged like a wheel on large platters, and this is at once more convenient and nicer to look at than a number of small plates. Small plates covered perhaps with paper doilies have a way of looking "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("derelict as soon as the party is under way. Cheese sticks, sablés, and biscuits can be aligned on wire trays which emphasize that they are fresh from the oven. Filled bridge rolls and sandwiches also look well on trays. Those items of food speared on small wooden sticks – olives, stuffed cherries, cheese or fish marbles and so on – may be conveniently collected for serving by using firm hearts of red and green cabbage into which the picks are stuck, presenting a porcupine-like aspect. The cabbages should be trimmed at the base and the lower leaves turned out, so that the whole stands firm. Polished apples, grape-fruit, lemons, and small marrows may be used in the same way. It is convenient, too, to have one main table on which the dishes are assembled, and by the way they are presented you may add to the gaiety and interest of the party.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("If you should decide on having no main dish, but choose instead a diversity of small things, these are best assembled in a generous way, avoiding too many small dishes. However many odds and ends you may choose to have, bear in mind the importance of contrast both of flavour and texture. Olives, nuts, and potato chips are always popular. The nuts should be freshly prepared and the chips properly heated through and salted. Certain types of savoury suitable for a cocktail party are equally suitable for serving as an after-dinner savoury, and the subject of this final course to a meal will be dealt with later. But the following general points may apply to both types of savoury and so I will give them here.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("1. When toast is used as a basis, the bread should be evenly sliced and about three-eighths of an inch thick. It should be toasted to a good brown and the crusts removed. It should be made at the last possible moment and dried off a little to allow the steam to evaporate before buttering.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("2. Fried canapés should be cut from evenly sliced rounds of bread about a quarter of an inch thick. They may be fried in shallow fat, in either butter or oil, according to the rules for shallow frying, i.e. the rounds should be turned once only. If they are fried in deep fat, they should be plunged into the smoking fat and turned about with a slice. Care should be taken not to let them become over-brown, or they will be hard and chippy.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("3. Where bacon rashers are used they should be streaky and cut very thin; a number three cut on the grocer’s bacon slicer is suitable. The rind is then removed with scissors and the rashers trimmed and spread out with the flat of a knife on a board. Half a rasher for each savoury is usually enough.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("4. Where anchovy fillets are called for they may well be soaked for some hours in milk, particularly if they have been preserved in brine, or have become hard and dry. If they have been preserved in brine they must be washed before being soaked. Picked shrimps may be treated in similar fashion.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("5. Cheese for grating should be dry, and the best all-round cheese is a dry, well-matured cheddar, or a mixture of gruyère and Parmesan. For Welsh rabbit or other toasted cheese dishes cheddar is most suitable.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("MAIN DISHES (HOT)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The keeping of these really hot does present a problem to the cook-hostess, for although one may serve them on a large hot fireproof dish, the savouries obviously will not retain heat for long. A chafing-dish is a valuable possession, and a hot-plate will help. Recently there have come on the English market deep dishes holding night-lights and covered with a perforated metal lid; these are less expensive than the two foregoing.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("A large hot fireproof dish filled with small mixed fritters is excellent, but it is difficult to keep them small enough to uphold the idea of ‘No two bites at a cocktail savoury.’ They should be made as small as is conveniently possible and reserved for a party where more substantial items are called for. They may be of vegetables, sprigs of herbs, prawns, mushrooms, onion rings and so forth. They should be ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("well flavoured and seasoned individually, dipped in a light fritter batter, and fried in deep fat. Piquant sauce may be served apart in a bowl into which the fritters are dipped. For this purpose they should be speared on picks. The recipe for a fritto misto of vegetables given on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10#page_236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 236")]), _vm._v(" will serve for this dish, and anyone of the really piquant sauces may be chosen; in particular I think the one called Alabama sauce is very good, as is the alternative given on "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#page_5"
    }
  }, [_vm._v("page 5")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If you want a small dish of one kind of fritter, I would choose mushrooms, for which you take small button mushrooms, season them well with salt and pepper and a dash of lemon juice, dip them into the fritter batter given below, and then fry them in deep fat to a golden brown. These again are served with a piquant sauce. Or your dish may be half these and half watercress puffs, for which you take sprigs of well-dried watercress, dip them in the batter, and fry.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Prawns, pieces of crawfish tail, and lobster may all be treated in the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Small, dry, well-seasoned fishcakes containing a touch of curry-powder or paste are a popular hot dish. Like the fritters these may be served on picks and dipped into a bowl of suitable sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("A LIGHT FRITTER BATTER FOR THE VEGETABLE AND HERB FRITTERS")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("150g/5 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a level teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("yeast about the size of a walnut")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("about 150ml/¼ pint water")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("When yeast is not available a substitute may be made of 1–2 tablespoons brown ale, in which event the amount of water may be reduced. The mixture should have the consistency of thick cream. Sift the flour and salt, dissolving the yeast in a little of the slightly warmed water and beating it into the flour with the remaining liquid.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here is a recipe for the small fishcakes:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PETITES CROQUETTES DE POISSON")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("cold fish that has been cooked in court bouillon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225ml/8 fl oz milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("110g/4 oz breadcrumbs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt, pepper, nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a dash of curry-powder")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("egg and breadcrumbs for coating")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Flake the fish, remove all skin and bone. Melt the butter, add the flour, and cook gently for a short time. Pour in boiling milk and whisk until the sauce thickens, add fish and breadcrumbs, season well with salt, pepper, nutmeg, and curry-powder. Spread the mixture on a plate to cool. Make into small croquettes, coat with egg and breadcrumbs, and fry golden brown in hot fat. Drain and serve hot.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("MAIN DISHES (COLD)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("One of the best of these I met with in Alabama. For this a large dish was filled with crushed ice, a hollow in the centre holding a glass bowl filled with Alabama sauce; all around, stuck in the ice, were picks holding Dublin Bay prawns; the prawns were dipped into the sauce and eaten. This is an admirable dish but by no means economical; however, the prawns may be replaced by the Norwegian frozen prawns, which are excellent, by pieces of crayfish or lobster, or even by dry, very well-seasoned fishcakes, "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("such as those already given.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("A recipe for Alabama sauce will be found on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06#page_154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 154")]), _vm._v("; the following is an alternative:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("AN ALTERNATIVE SAUCE TO ALABAMA TO SERVE WITH FRITTERS OR SHELL-FISH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Make a good cream dressing or mayonnaise and add to it 1 dessertspoon wine vinegar, 1 tablespoon salad-oil, salt, freshly ground black pepper and made mustard to taste, 1 heaped teaspoon sugar, 2 teaspoons grated horseradish, chopped chives and spring onions, a squeeze of lemon juice, and a dash of tomato ketchup. Beat all together and add finely chopped gherkins, capers, or sweet pickles.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Another good main dish is made with a form of home-made cheese beaten to a light cream, piled lightly on a dish, surrounded by chipped potatoes, radishes, gherkins, olives and so forth, and accompanied by a separate dish of plain hot biscuits, preferably salted. The cheese is either spooned on to the biscuits or scooped up with potato chips. The cheese for this dish may be made in a variety of ways, and here is one simple recipe:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("HOME-MADE ‘CREAM’ CHEESE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("cheddar cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("butter up to an equal quantity with the cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("hot milk, cream, or yoghourt, or a mixture of all three, may be used in place of part or all of the butter. Additional bulk may be given by the incorporation of home-made sour-milk cheese, as given on "), _c('span', {
    staticClass: "color1",
    attrs: {
      "href": "#/xhtml/31_Chapter25#page_648",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 648")]), _vm._v(" in the milk and cheese chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("flavourings added to taste: a dash of anchovy essence and/or Worcestershire sauce, chopped capers, olives, gherkins, sweet pickle, chives, crushed garlic")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasonings: salt, paprika, freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Grate the cheese and pound, or put it through a wire sieve. Beat it well, adding the other ingredients. Taste for seasoning and flavouring. If this cheese is to be used in quantities as a main dish the flavouring should be fairly restrained. If, however, it is wanted for canapés the stronger form of it known as Liptauer may be made. See "), _c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter25#page_649",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 649")]), _vm._v(" of the milk and cheese chapter or the good luncheon cheese given on "), _c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter25#page_649",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 649")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("SMALLER SAVOURIES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cheese enters into many cocktail savouries, ranging from tiny Welsh rabbits to sables and cheese creams for filling savoury éclairs and choux, and recipes for some of these savouries are now given.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CAMEMBERT SAVOURY")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("trimmings of puff pastry")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("olives")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt, pepper, and cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Camembert cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Roll the puff paste thin and cut in strips. Bake light brown in a hot oven, and sandwich with Camembert cheese worked with an equal quantity of whipped cream, seasoned with salt and pepper and a dash of cayenne, and mixed with a few stoned, chopped olives. Serve hot or cold.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("CREAM CHEESE CANAPÉS (1)")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Make a rich short crust with 75g/3 oz flour, 50g/2 oz butter, 25g/1 oz cheese, 1 egg yolk, and seasoning. Roll and stamp into rounds the size of half a crown and bake for 7 minutes. Pipe on to these, or put on with a teaspoon, a good creamed cheese such as Liptauer. Into this you may put chopped chives, pounded anchovies, tomato purée, and paprika to taste. Decorate the canapés with black olives, pickled walnuts, pickled onions, or gherkins.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CREAM CHEESE CANAPÉS (2)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Beat demi-sel or home-made cheese with a little cream to the consistency of whipped cream. Season well, pipe on to small rounds of cheese sables (see recipe below), decorate with red-currant jelly or pickled cucumber.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("A recipe for Cheese Marbles (Hot) will be found on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter12#page_309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 309")]), _vm._v(" (Salads).")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CÉLERI FARCI")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1-2 heads of first quality celery")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("25-50g/1-2 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("brown bread and butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50-75g/2-3 oz Stilton cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("pimento")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut the root off the celery, carefully detach the stems, and wash well. Discard any stringy or discoloured stems. Put the remainder into cold water and leave to become crisp. Meanwhile cream or pound the Stilton with enough butter to make it taste mild and good – the quantity depends on the ripeness of the cheese – and season well with salt and pepper. Dry each stem of celery well, and with a small palette-knife spread the cheese mixture inside the stems, starting with the smallest and reshaping the stalks into two or three ‘heads,’ according to the size of savoury desired. Wrap each ‘head’ in grease-proof paper and put aside in a cool place to become firm. Then cut each ‘head’ crossways into slices about 5mm/¼ inch thick, and set each on a round of brown bread and butter stamped out to exactly the same size as the slice of celery. Garnish with a very small round of canned pimento put in the middle of each slice. The nozzle of a forcing-pipe about 5mm/¼ inch in diameter is a good cutter for the pimento.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("N.B. Chicory may take the place of celery when the latter is not in season, but it is not so crisp.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CHEESE SABLÉS")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz grated cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Rub the butter into the flour and add the grated cheese and seasoning. Leave in a cool place for 10 minutes. Roll out to 5mm/¼-inch thickness and cut into wide strips, then into triangles. Bake 10 minutes in a fairly hot oven.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Almond sables filled with a creamy filling are delicious, and a recipe for them will be found in the milk and cheese chapter ("), _c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter25#page_655",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 655")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("WALNUT SABLÉS")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz grated cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("beaten egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("coarsely chopped walnuts")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("rock-salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Rub the butter into the sifted flour and add the cheese with the seasoning. Knead together into a paste. Roll out thinly. Cut into strips about 5cm/2 inches wide. Brush over with beaten egg and sprinkle thickly with the walnuts. Grind a little salt over this and cut each strip into triangles. Bake on a tin lined with grease-proof paper in a moderately hot oven till golden brown, about 10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CHEESE STRAWS")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("175g/6 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("85g/3½ oz butter or margarine")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz grated Parmesan or Parmesan and gruyère cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt, pepper, and cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("yolk of 1 egg or a little beaten egg")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Rub in the fat lightly, add the grated cheese and seasoning, and bind with the egg yolk or beaten egg, and a spoonful of water if necessary. Roll out and shape into a rectangle; cut across into strips and bake on a paper-lined baking-sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A range of cocktail savouries made with choux pastry maybe light, agreeable, and easy to vary:")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TARTELETTES À LA MARJOLAINE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Line very small tartlet moulds with a savoury short pastry. Prick the bottom of each case and line with paper and beans to keep the shape. Bake 10–15 minutes in a hot oven.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Prepare a choux paste in the usual way (see ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter28#page_732",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 732")]), _vm._v(") with the addition of 50g/2 oz grated cheese at the last. Fill this into a bag with a small round pipe, and pipe round the bottom and sides of the tartlets so as to form a small well in the middle. Fill in with a thick creamy béchamel sauce, well seasoned, and with grated cheese added. Put the tartlets into a moderate oven for another 10–15 minutes, in order to cook the choux paste gently whilst browning the middle of the tartlets. Serve very hot, and immediately, when they become like a soufflé. In larger tartlet moulds these make a good savoury.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "h3-italic"
  }, [_vm._v("Béchamel sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Bring 150ml/¼ pint milk slowly to the boil with a bay-leaf, a slice of onion, and a blade of mace. Strain carefully on to a roux of a good 15g/½ oz each of flour and butter. Stir till boiling, simmer a minute or two, add cheese to taste, and plenty of seasoning.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As well as the following recipes there is one for Beignets Soufflés au Fromage in the milk and cheese chapter on "), _c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter25#page_655",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 655")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SAVOURY ÉCLAIRS OR CHOUX")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Prepare a choux paste with 150ml/¼ pint water, 50g/2 oz butter, 60g/2½ oz flour, seasoning, and 2 eggs (for method see "), _c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter28#page_732",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 732")]), _vm._v("). Lightly grease a baking-sheet and put the mixture on it in small teaspoons. Sprinkle with chopped almonds or grated cheese and bake until crisp, or you may mix savoury "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("ingredients in the paste:")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Choux paste as above, season with salt (no sugar), mix with a little chopped lean ham or, more delicious, smoked ham and shredded browned almonds, and fry in deep fat.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Or you may fill cooked choux paste:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bake the paste plain as choux, or pipe into little éclairs, split and fill with cheese cream or other savoury mixture. Or you may like to incorporate a little cheese with the mixture to give added interest.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In Edwardian days these savoury éclairs and choux were called carolines when shaped like éclairs, and duchesses when formed like choux à la crème; they were finished off, after being filled, by a coating of chaudfroid sauce or by a light brushing of aspic jelly just on the point of setting, and they were then sprinkled with finely chopped pistachios or other salted nuts. This finish is not often carried out to-day and is indeed a job for experts. The addition of sauce or aspic, of course, makes these savouries suitable for the dinner table rather than the cocktail party. Some of the fillings used for them, however, will serve our purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Chicken.")]), _vm._v(" Cold chicken, shredded and pounded in a mortar, mixed with an equal quantity of butter and seasoned with salt, freshly ground black pepper, a squeeze of lemon juice, and a few drops of tabasco. Finely chopped herbs, such as tarragon, chervil, and parsley, can be worked into the mixture to taste.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Ham.")]), _vm._v(" Lean ham, with a very little fat added, shredded and pounded with enough hot chutney to flavour, a drop or two of Worcestershire sauce, some French mustard, and an equal quantity of butter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Tongue,")]), _vm._v(" shredded and pounded with a tablespoon of Cumberland sauce, salt and pepper, a touch of made mustard, and an equal quantity of butter. Chopped orange or lemon rind added to taste.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Salmon.")]), _vm._v(" Fresh or smoked salmon, pounded and mixed with horseradish sauce, seasoned with salt, pepper, and lemon juice.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Sardine.")]), _vm._v(" Boned and skinned sardines pounded with lemon juice, plenty of freshly ground black pepper, a little salt, and a teaspoon or more of Worcestershire sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("N.B. Instead of butter, a small quantity of good béchamel or demi-glace sauce, according to the other elements chosen, may be used with these purées.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("In the following three fillings cream is given as a binding medium. This is classic, but in these days, when the general range of foods is much less rich, it is advisable to consider a good béchamel in its place. This produces a lighter and to some people a more agreeable texture.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Smoked salmon.")]), _vm._v(" Well pounded and mixed with 2 tablespoons of thick cream to every 110g/4 oz of salmon. Passed through a fine sieve, seasoned with lemon juice and freshly ground black pepper. If the mixture tastes too strong, a little more whipped cream may be added.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Tunny.")]), _vm._v(" Well pounded and mixed with the same proportion of thick cream or butter as the previous filling. Passed through a fine sieve and seasoned with black pepper, salt, and a little anchovy essence; garnished with chopped fennel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "rad"
  }, [_vm._v("Chicken, ham, and tongue.")]), _vm._v(" Made according to the same proportions, seasoned and flavoured as for smoked salmon, passed through a fine sieve and mixed with a little extra whipped cream.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SAVOURY FRITTERS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Prepare a choux paste as described on 732. When well beaten, add to this 50g/2 oz finely shredded lean ham and 40g/1½ oz shredded browned almonds. Fry in hot fat in ½-teaspoons. When well risen and firm, drain on soft paper and serve at once.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("TOASTED SARDINE SANDWICH")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Skin, bone, and mash up a small tin of sardines and add 4 tablespoons good thick cream salad-dressing, coleslaw, or well-flavoured mayonnaise. Add ½ dessertspoon Worcestershire sauce, a dash of tabasco, ½ teaspoon finely chopped chives, 4–5 tablespoons finely chopped celery or cucumber, a tablespoon of finely chopped green peppers, ½ teaspoon lemon juice, salt and pepper. Mix this all together, beat it up, and spread it thickly between rounds of bread, then toast under a grill, turning carefully and toasting on each side; or the whole may be cooked in a frying-pan in butter.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("The grilled sardines mentioned in the section on after-dinner savouries (")]), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#page_27"
    }
  }, [_vm._v("page 27")]), _vm._v(") may be made in small size and are an excellent hot cocktail savoury.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SARDINE CANAPÉS")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("small croûtes or rounds of brown bread and butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("sardines")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("slices of hard-boiled egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("slices of lemon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chopped capers")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Bone and skin the sardines and lay one on each croûte, cover with a slice of egg and a slice of peeled lemon. Dust with chopped parsley and chopped capers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Here is a refreshing mixture for canapés:")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 cream cheese the size of a demi-sel")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 tablespoons thick cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("12 olives, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon green peppers, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon Worcestershire sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Beat together and put on croûtes or biscuits or ice wafers brushed with butter and crisped in the oven.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("ANCHOVY ROLLS")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("fillets of anchovy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("dry grated cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("thin white bread and butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("mustard and seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("melted butter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut the crusts off the bread and butter, spread each slice with mustard, sprinkle with seasoning and cheese, lay on a fillet of anchovy, and roll up. Set on a tin, sprinkle lightly with melted butter, and bake in a hot oven for 7 minutes to a golden brown. Serve very hot. These must be cut to an even size, and the slice should be medium-sized to small, so that each roll is not too ‘bready.’")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("ANCHOVY AIGRETTES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Prepare a French dressing with plenty of herbs, oil, and vinegar, chives and parsley. Marinade with this for as long as possible anchovy fillets, then drain, dip into fritter batter, and fry at once in deep fat. Or the fillets may be laid on thin pieces of short or puff pastry and turned over to form "), _c('i', [_vm._v("allumettes")]), _vm._v(". They are painted with beaten egg and baked.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("The following shell-fish canapés may serve either as cocktail savoury or first course for dinner according to their size. The recipes may be interchanged or used with other shell-fish. The difference between them is that the one given for crab is creamy and bland and that for lobster much more piquant.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("CRAB CANAPÉS")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("1 shallot")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a scant 25g/1 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 tablespoons cream or creamy milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("fingers of toast or fried bread")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("paprika")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz crab meat")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon grated cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("watercress to garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Chop the shallot finely, make 15g/½ oz butter hot in a frying-pan, and cook the shallot gently until light brown. Add the flour, off the heat, and blend well. Pour in the cream or milk and bring to the boil, add the flaked crab and season well with salt, pepper, cayenne, and lemon juice. Stir until boiling-point is reached. Spread the fingers of toast or fried bread with the mixture, work the cheese and the rest of the butter together to a paste with a fork or a palette-knife, and add plenty of paprika to make the paste a good red colour. Spread a little of this paste on top of each. Put for a second or two under a hot grill, and garnish the dish with bunches of picked watercress.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("LOBSTER CANAPÉS (COLD)")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("the meat from 1 small lobster,")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("or a small tin of lobster")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("French dressing")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 sprigs of parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 rasher of bacon, thinly cut")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("mayonnaise or boiled dressing")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 sticks of celery, finely chopped, or a good tablespoon chopped celeriac")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("6 chives")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("fingers of toast or fried bread")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("lettuce to garnish")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Break up the lobster meat into small pieces with two forks and marinade for an hour or more in well-seasoned French dressing, to which a pinch of sugar has been added. Add the finely chopped celery or celeriac, the chives cut small with kitchen scissors, and finely chopped parsley. Cut rind from bacon, grill until brown and crisp, and break in small pieces. Add these to the lobster mixture when cold, and mix with mayonnaise or dressing. Season with salt and freshly ground black pepper. Pile on fingers of fried bread or toast and garnish with small lettuce leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SHRIMP CANAPÉS (HOT OR COLD)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Simmer shrimps in a little butter with a pinch of curry-powder and a dash of cayenne. Arrange on croûtes and put a little chilli sauce on top.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("DEVILLED CROQUETTES OR KROMESKI (1)")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Cod’s roe or devilled crab shaped into small balls and sandwiched between two halves of a walnut, floured, egged and crumbed, and fried in deep fat. (See also ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#page_31"
    }
  }, [_vm._v("page 31")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("DEVILLED KROMESKI (2)")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("10–12 large prunes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("stock")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("chutney")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("fillets of anchovy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("bacon rashers")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("batter of 2 tablespoons flour, salt and pepper, and a piece of yeast the size of a pea")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Soak the prunes overnight and simmer until just tender in a little good stock. Remove the stones carefully. Stuff with the anchovy fillets and a good ½ teaspoon of chutney. Make a batter by dissolving the yeast in 2 or 3 tablespoons warm water, then beating in the flour with a little cold water to make a thick cream. Leave the batter for 15 minutes in a warm place before it is used. Roll the prunes in a piece of bacon, dip in the batter one by one, and then drop into smoking deep fat. Fry to a golden brown. Serve very hot in a napkin.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("DEVILLED CHESTNUTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These may be used as cocktail savouries or as a hot hors-d’œuvre. Take large chestnuts, scald them, and remove the outer peel and every bit of the inner skin without breaking the chestnuts. Stew gently in milk with a little salt, till they are soft enough to penetrate with a skewer without losing their shape. Roll each nut in oiled butter and then cheese mixed with a good sprinkling of pepper, salt, and cayenne. Roll in butter once more and then in fried breadcrumbs. Place on a dish in a fairly hot oven, pour a little oiled butter carefully over them, and leave them to brown, which takes a few minutes. Serve in little paper cases and sprinkle at the last minute with a little chopped chervil and a dust of cayenne. Serve very hot. This is one of the most popular of cocktail savouries.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CHESTNUT CROQUETTES")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("See ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter20#page_559",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 559")]), _vm._v(" in poultry chapter. These are excellent as a hot cocktail savoury and very popular.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MUSHROOM ROLLS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Take thin slices of streaky bacon, cut off the rind, flatten with a knife, and spread with a well-seasoned mushroom purée. Roll up, brush with beaten egg, dip in breadcrumbs or oatmeal, and fry in deep fat.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "h3-italic"
  }, [_vm._v("Purée")])]), _vm._v(" "), _c('div', {
    staticClass: "space1"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz shallots")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("225g/8 oz mushrooms, washed, peeled, and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50g/2 oz white breadcrumbs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("seasoning")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cook first four ingredients gently for 10 minutes. Add breadcrumbs and chopped parsley.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If mushroom rolls are to be served as a savoury course at the end of a meal, they may be accompanied by watercress tossed in sharp French dressing.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BACON ROLLS IN DROPPED SCONES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Roll a thin rasher of bacon, or part of one, round a pickled onion, and cook until the bacon is thoroughly done. Make small, thin, unsweetened drop scones and fold them round the roll, holding together with a wooden skewer.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Small, unsweetened drop scones, freshly made, may be filled in a variety of ways, or spread with savoury pastes, such as Gentleman’s Relish or good bloater paste, and served rolled up. They are excellent, if not economical, filled with pâté de foie gras.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("There is one particularly delicious cocktail savoury, Guacamole, which one serves in this country only when avocado pears can be bought inexpensively, which sometimes happens, particularly in the French market in London in the summer. For this the flesh of the avocado pear is beaten up with sour cream, onion juice, lemon juice, and seasoning, then well chilled and served with brown bread and butter on which it is spread, or with a dish of potato chips beside the bowl for dipping into the mixture. This is a particularly delicious and epicurean dish.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CUCUMBER AND TUNNY FISH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Peel a large cucumber, cut in half (not lengthwise), scoop out seeds. Fill with mashed tunny fish flavoured with mayonnaise, paprika, and Worcestershire sauce. Pack in well with a spoon handle. Leave several hours in the refrigerator. Cut in ½-inch slices. Serve on lettuce moistened with French dressing.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CUCUMBER FARCI")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Pieces of cucumber stuffed with a cream cheese or mushroom purée and set on rounds of brown bread and butter.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("STUFFED GRAPES")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Pip large grapes. Make a paper cornet (see ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#page_44"
    }
  }, [_vm._v("page 44")]), _vm._v("). With this fill each grape with a soft cheese cream, well seasoned with black pepper and salt. Allow the cheese cream to come well above the top and dip this into salted browned almonds. Serve on picks or in small paper cases.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("STUFFED PRUNES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Soak the prunes well overnight, then remove the stones. Finely chop together 3 shallots, a chicken liver, and 25g/1 oz fat bacon. Heat a nut of butter in a small sauté pan, add the onion, bacon, and liver, and simmer for about 5 minutes. Season well, adding plenty of finely chopped parsley and sage or savory. Bind together with the yolk of an egg and stuff into the prunes. These may be served hot.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SALTED AND DEVILLED NUTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Almonds and filberts are blanched, peanuts are slipped from their thin brown skins before salting. Walnuts when fresh must not have the skin left on as it is very bitter. The nuts are lightly fried in butter, then drained and tossed in salt sprinkled on kitchen paper; for devilled nuts, cayenne is added to the salt.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("COCKTAIL SAUSAGES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These are always popular and are interesting if they are treated as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cook chipolatas, make an incision lengthways, but do not quite cut through. Spread inside with French mustard and fill with cream cheese well flavoured with chutney or with devil sauce. Roll the edge in browned chopped almonds.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Tiny Vienna smoked sausages (bought in jars) may be wrapped in wafer-thin puff paste, baked, and served on picks, or one may take chipolatas, splitting them and encasing them in pastry in the same way. They are baked and served cut in short lengths, on picks.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("FILLED ROLLS")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("There is a whole range of filled rolls, minute, medium, or sizable, according to the occasion, which are good as long as they are not overdone. Assembled in one large dish they may, if you so wish, make a central feature of the table. The fillings for them are capable of great variation and are a matter for the imaginative. If one chooses tiny French or homemade rolls these are easily handled, but it must be acknowledged that savouries are lighter and less bready if one uses starch-less rolls bought in packets and called Energen. The trouble here is that even half of one of these is on the large side and they are inclined to crumble, and perhaps savouries made with these find a better place as a first course for luncheon or dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("From the rolls cut off a slice and hollow slightly; brush inside and out with flavoured butter, garlic-flavoured if you like. After brushing put them into a sharp oven until golden brown, and then they may be filled in a variety of ways: pieces of chicken in devil or curry sauce; crab with a sharp dressing of oil, vinegar, plenty of mustard, salt and pepper; devilled mushrooms, cheese, or anyone of a variety of fillings you may choose. The great point about these rolls is that they shall be very crisp and the filling well seasoned. They may of course be lavish or economical as your purse allows.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Another kind of filled roll is made by making tiny home-made croissants and filling them before they are baked – that is to say the roll and filling are baked together. The filling may be of ham, mushroom, devilled hard-boiled egg, or anything you may choose.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Here is a good devil sauce for binding together such things as hard-boiled eggs, diced chicken, mushrooms, etc., for filling rolls.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("DEVIL SAUCE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("4 tablespoons Harvey’s sauce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 level teaspoon made English mustard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 tablespoons tomato sauce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a good pinch of cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a dash of anchovy essence")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("brown sauce, béchamel, or")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("mayonnaise")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cook all ingredients but the last together to make a sauce of coating consistency which tastes both sweet and sharp. Add to this mixture 150ml/¼ pint of béchamel, or if to be served cold use a small quantity of mayonnaise sufficient to bind, or a thick brown sauce. Mix this with the hard-boiled egg or chicken, cut fairly coarsely, and put a dessertspoon of the mixture in each roll, putting back the top at an angle. The rolls may then be heated in a hot oven for 7-10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("POTATO STICKS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Potato sticks are excellent to eat by themselves or with cheese or salad, and they are liked by children as well as older people.")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz freshly cooked sieved potato")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("75g/3 oz flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt, pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("beaten egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("dill or caraway seed")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Work the potato, butter, and flour to a soft dough, with plenty of salt and pepper. Then leave for half an hour to chill. Roll out, brush with beaten egg, sprinkle well with dill seed, cut into sticks. Bake in a moderate oven 10-15 minutes.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("CHUTNEY BISCUITS")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Take thin water-biscuits or the ‘last-minute’ biscuits given on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter26#page_683",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 683")]), _vm._v(". Make a mixture of a little butter worked well with Worcestershire sauce, a teaspoon of sieved chutney, and a dash of paprika. Spread this mixture on the biscuits and bake in a quick oven for about 5 minutes. Serve very hot. With these may be served in a separate dish ice-cold mint and apple chutney which one spoons on to the biscuit. This contrast in temperatures is excellent.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The following biscuit has a covering of thin, highly seasoned jelly or aspic. It can be most refreshing in flavour and a good contrast in texture to other savouries, but the jelly must be really hotly seasoned.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BISCUITS WITH SAVOURY DEVILLED JELLY")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("150ml/¼ pint chilli, tomato, or A1 sauce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a dash of Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("small thin water-biscuits")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon powdered gelatine")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt, pepper, and cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("stoned olives stuffed with anchovy butter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Dissolve the gelatine in a tablespoon of water, and mix it with the bottled tomato, A1, or chilli sauce. Add a dash of Worcestershire sauce and season with salt, pepper, and a spot of cayenne. Pour on to a wet plate to set. When quite firm, cut in rounds with a pastry cutter, and put each round of jelly on a small round cheese biscuit. In the middle set a stoned olive stuffed with anchovy butter.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PIN-WHEELS OR ROULADES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These are made by taking small pieces of pastry left over from other bakings and rolling them out extremely thinly. The pastry is then spread with anchovy or bloater paste, or a highly seasoned paste such as Gentleman’s Relish, and rolled up like a small Swiss roll. This should be allowed to chill thoroughly and then be finely sliced, the slices being baked in the oven. This is a useful type of simple cocktail savoury for everyday use, for if the roll is wrapped in grease-proof paper and kept in the refrigerator it will keep for days and may be sliced and used as required.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BOUCHÉE")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("puff pastry")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("lean ham")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("beaten egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("piquant sauce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("parsley")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Roll out the pastry, brush over with beaten egg, stamp out into rounds about the size of a five-shilling piece. To imitate the appearance of larger bouchées mark a well-defined circle with a smaller cutter in the centre (these little bouchées are split for filling instead of being filled like the larger ones). Bake in a hot oven till well risen and crisp. In the meantime, chop the ham, mix it well with the chopped parsley and enough piquant sauce to moisten well. Split the bouchées in two and fill well with the mixture. Serve hot or cold.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Small tartlet cases filled in various ways are attractive. Tunny-fish cream makes a good filling and the finish may be of a turned olive, or of a turned olive stuffed with pimento. Olives associate particularly well with tunny fish, now generally available, and are most suitable for cocktail savouries of many kinds.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There is no need to set out a list of fillings for bouchées as a choice may be made from those already suggested, chicken, hard-boiled eggs, lobster, mushroom, etc., bound together by a good béchamel.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("SAVOURY BUTTERS")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This seems a not entirely unsuitable place to mention savoury butters. These are of course used in many dishes in what R. H. calls ‘proper cooking,’ but as they are often useful for some of the foregoing kickshaws they may reasonably come in here.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MAÎTRE D’HÔTEL BUTTER")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon finely chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cream the butter well on a plate with a palette-knife, work in the lemon juice a few drops at a time with the parsley and seasoning. When all is thoroughly mixed, form into pats or spread out on a small plate and cut into squares when hard. Leave to harden well before using.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A pat is put on grilled sole, cutlets, tournedos, poached eggs, etc., immediately before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MONTPELLIER BUTTER")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 hard-boiled egg yolk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 or 3 leaves of spinach")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 sprigs of tarragon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 fillets of anchovy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("a small handful of parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("salt and pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Boil the herbs together for 5 minutes, drain, press, and pass through a wire sieve or strainer. Pound or sieve the yolk with the anchovy, work into the butter, adding the herb purée by degrees; the butter should be quite green. Season rather well.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Use as a sandwich filling, or with eggs, fried fish, and as maître d’hôtel butter.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("ANCHOVY BUTTER")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("25g/1 oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("anchovy essence")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 fillets of anchovy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ clove of garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Work the butter on a plate with a palette-knife until creamy; pound the anchovies and add to the butter with the pepper and enough essence to colour a delicate pink and strengthen the flavour. Crush the garlic to a cream with a pinch of salt, and mix in thoroughly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For boiled, grilled, fried, or poached fish, and for adding to a béchamel or velouté sauce to form sauce aux anchois. In this case, omit the garlic and use finely ground white pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("ORANGE BUTTER")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("finely grated rind of 1 orange, preferably blood")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon paprika pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon or more orange juice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("40g/1½ oz butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 slice of shallot well crushed with a pinch of salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cream the butter thoroughly and work in the other ingredients by degrees. Leave to harden and use as for maître d’hôtel, but principally for grilled sole. It is also good with stuffed chipolatas.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("GARLIC BUTTER")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Blanch 25g/1 oz garlic, pound in a mortar, work in 25g/1 oz butter and put through a fine sieve. Use for flavouring sauces, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("CHIVRY OR RAVIGOTE BUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Pound in a mortar 75g/3 oz (altogether) of parsley, chervil, tarragon, and chives, blanched for a few minutes, refreshed, and squeezed. Pound also 1 shallot, chopped and blanched. Add 40g/1½ oz butter and put through a fine sieve.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("SHRIMP BUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Pound peeled shrimps in a mortar to a paste. Add an equal quantity of butter, season with a squeeze of lemon juice, and pass through a fine sieve.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TARRAGON BUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Blanch 25g/1 oz tarragon leaves for 2 minutes, drain, refresh, and squeeze. Pound them with 50g/2 oz butter and pass through a fine sieve.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("MUSTARD BUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Add 1½ tablespoons French mustard to 110g/4 oz softened butter, work together, and keep in a cool place. For fish, grilled ham, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PAPRIKA BUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Soften in butter a tablespoon of finely chopped onion. Add a dessertspoon of paprika, work into 50g/2 oz butter, and pass through a fine sieve.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("PIMENTO BUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Pound 1 red pimento, tinned, cut in small pieces, with 75g/3 oz butter, salt, pepper, and cayenne, 1 tablespoon thick cream, and a squeeze of lemon juice. Pass through a fine sieve.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("BEURRE À L’INDIENNE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Pound a good tablespoon of mango chutney with a teaspoon of curry-powder, add a teaspoon of made mustard, 75g/3 oz butter, a squeeze of lemon juice, salt, pepper, and a spot of cayenne. Add a few drops of Worcestershire sauce and spread on the bread or toast used for chicken sandwiches.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("LOBSTER BUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Pound together equal parts of the coral from a cooked lobster and butter. Season and press through a nylon sieve. Sometimes a recipe calls for lobster butter made from uncooked coral; the method is the same.")])]), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("FRUIT COCKTAILS")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The selection and mixing of cocktails is outside the proper scope of this book; there are other more suitable sources of information. It is a good plan to have one short drink that is non-alcoholic and the most generally popular is tomato juice. Recipes for making this follow. Often a tin of a good brand of tomato juice is used and seasoning and lemon juice added to this.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TOMATO JUICE COCKTAIL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Simmer 12 tomatoes in ½ cup water with a sliced onion, a small stick of celery (or celery salt), ½ bay-leaf, 3 sprigs of parsley, and 4 sprays of basil. Strain and season with salt, paprika, a little sugar, a dash of Worcestershire sauce (optional), and a squeeze of lemon juice. Chill well.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TOMATO COCKTAIL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("To 600ml/1 pint good strong tomato juice, made from ripe tomatoes, add the pared rind and juice of half a lemon, a teaspoon of mint-flavoured vinegar, a teaspoon of Worcestershire sauce, sugar, salt, and freshly ground pepper to taste, and a grating of nutmeg. Chill for an hour or two in the refrigerator before removing the lemon rind.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("ORANGE AND TOMATO COCKTAIL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Bruise 3 or 4 sprigs of pineapple mint, put into a jug and pour over them 600ml/1 pint good tomato juice, add 225ml/8 fl oz freshly strained orange juice, a good pinch of salt, and sugar to taste. Chill thoroughly and allow to infuse for at least an hour before straining.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Other recipes for fruit cocktails will be found on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter37#page_1027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 1027")]), _vm._v("-"), _c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter37#page_1028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1028")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8bc2ed8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter01.vue
// module id = 72
// module chunks = 0